import * as THREE from 'three';
import { C } from '../core/palette.js';
import { cyl, sphere } from '../core/meshkit.js';

// The Avocados — the crew that runs the court. A green avocado body with a big
// brown pit belly, dot eyes and stick limbs. They idle-bob and throw their arms
// up to cheer when Bread Boi sinks a basket. Build once, add .root to the scene,
// call update(dt) each frame and cheer() on a made shot.

export class Avocado {
  constructor({ scale = 1, tone = C.sproutDim } = {}){
    this.root = new THREE.Group();
    this.root.scale.setScalar(scale);

    // body: an avocado-shaped ellipsoid (narrow top, round bottom)
    const body = sphere(0.5, tone, 0, 0.95, 0, this.root, 18);
    body.scale.set(1, 1.4, 0.95);
    const neck = sphere(0.3, tone, 0, 1.5, 0, this.root, 14);
    neck.scale.set(1, 1.1, 0.95);

    // the pit — a big brown belly
    const pit = sphere(0.26, C.rye, 0, 0.9, 0.34, this.root, 14);
    pit.scale.set(1, 1.1, 0.7);

    // face on the upper "neck"
    sphere(0.055, C.cocoa, -0.15, 1.6, 0.28, this.root, 8);
    sphere(0.055, C.cocoa,  0.15, 1.6, 0.28, this.root, 8);
    const smile = cyl(0.09, 0.09, 0.04, C.cocoa, 0, 1.46, 0.3, this.root, 10);
    smile.rotation.x = Math.PI / 2; smile.scale.set(1.5, 1, 0.5);

    // stick arms (pivot at the shoulder so we can raise them to cheer)
    this.armL = this._arm(-0.5); this.armR = this._arm(0.5);
    this.root.add(this.armL.pivot, this.armR.pivot);

    // little legs
    cyl(0.05, 0.05, 0.4, C.limb, -0.2, 0.2, 0, this.root, 6);
    cyl(0.05, 0.05, 0.4, C.limb,  0.2, 0.2, 0, this.root, 6);

    this.baseArmZ = { l: 0.6, r: -0.6 };
    this.cheerT = 0;
    this.phase = Math.random() * Math.PI * 2;
  }

  _arm(side){
    const pivot = new THREE.Group();
    pivot.position.set(side * 0.5, 1.15, 0.05);
    const limb = cyl(0.04, 0.04, 0.5, C.limb, 0, -0.25, 0, pivot, 6);
    pivot.rotation.z = side > 0 ? -0.6 : 0.6;
    return { pivot, side: Math.sign(side) };
  }

  cheer(){ this.cheerT = 0.9; }

  update(dt){
    this.phase += dt * 3;
    const bob = Math.abs(Math.sin(this.phase)) * 0.06;
    this.root.position.y = bob;

    if (this.cheerT > 0){
      this.cheerT -= dt;
      // arms shoot up and pump
      const up = 2.2 + Math.sin(this.phase * 2.5) * 0.3;
      this.armL.pivot.rotation.z = up;
      this.armR.pivot.rotation.z = -up;
      this.root.position.y = bob + 0.12;         // hop while cheering
    } else {
      this.armL.pivot.rotation.z = this.baseArmZ.l + Math.sin(this.phase) * 0.1;
      this.armR.pivot.rotation.z = this.baseArmZ.r - Math.sin(this.phase) * 0.1;
    }
  }
}
